<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Tournament Revenue<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>

          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button> -->
        </div>
      </div>

      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadTournamentRevenue(lastTableLazyLoadEvent); getAcademyTournamentList();" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
            <div class="divider ">
            <hr>
          </div>
            <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>The revenue and other counts shown is calculated based on the tournament start date, considering all tournaments from the launch of the application.</li>
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
          <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                    (onChange)="getAcademyTournamentList(); loadTournamentRevenue(lastTableLazyLoadEvent);" placeholder="Select Sport"
                    optionLabel="name" optionValue="name" appendTo="body"
                    [(ngModel)]="sportName"></p-dropdown>
                </li>
                <li>
                 <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                    (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>
               
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                    (onChange)="getCities($event)" placeholder="Select State" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                  <li>
               <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                    (onChange)="loadTournamentRevenue(lastTableLazyLoadEvent)" placeholder="Select City"
                    optionLabel="name" optionValue="name" appendTo="body" [showClear]="true"
                    [(ngModel)]="cityName"></p-dropdown>
                </li>
                 <li>
                <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                    (onChange)="loadTournamentRevenue(lastTableLazyLoadEvent)" placeholder="Select Academy"
                    optionLabel="academyName" optionValue="academyId" appendTo="body" [showClear]="true"
                    [(ngModel)]="academyId"></p-dropdown>
                </li>
              
                <li>
                <p-dropdown inputId="totalCoaches" [options]="academyTournamentsList" [filter]="true"
                    (onChange)="loadTournamentRevenue(lastTableLazyLoadEvent)" placeholder="Select Tournament"
                    optionLabel="name" optionValue="tournamentId" appendTo="body" [showClear]="true"
                    [(ngModel)]="tournamentId"></p-dropdown>
                </li>
              </ul>
            </div>
          </div>
          <div class="detailsList">
          <ul>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Number of Users</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalNumberOfUsers }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Registrations</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalRegistrations }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total No. of Tournaments</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalNumberOfTournaments }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Registration Amount</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalRegistrationAmount }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (Host)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalCouponAmountHost }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Coupon Amount (TPL)</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalCouponAmountTPL }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Commission</h6>
                  </div>
                  <div class="mainText">
                    <!-- <h3> {{ tournamentRevenueData?.summary?.totalTPLCommission }}</h3> -->
                    <h3>{{ formatCommission(tournamentRevenueData?.summary?.totalTPLCommission) }} </h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Entry Fee Payout to Academy</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalEntryFeePayoutToAcademy }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total Revenue</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalRevenue }}</h3>
                  </div>
              </div>
            </li>
            <li>
              <div class="cardDiv">
                  <div class="titleHeading">
                    <h6>Total TPL Share</h6>
                  </div>
                  <div class="mainText">
                    <h3>{{ tournamentRevenueData?.summary?.totalTPLShare }}</h3>
                  </div>
              </div>
            </li>
          </ul>
        </div>  
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="tournamentRevenueData?.data" [autoLayout]="true" [paginator]="true"
              [rows]="10" [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadTournamentRevenue($event); getAcademyTournamentList();" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap" pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon field="mobileNumber"></p-sortIcon></div>
                  </th>

                  <th pSortableColumn="username" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="username"></p-sortIcon></div>
                  </th>

                  <th pSortableColumn="academy" class="academyTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy <p-sortIcon field="academy"></p-sortIcon></div>
                  </th>

                  <th class="sportTD" pSortableColumn="sport">
                    <div class="p-d-flex p-jc-between p-ai-center"> Sport <p-sortIcon field="sport"></p-sortIcon></div>
                  </th>

                  <th class="transferCreditTD" pSortableColumn="registrationId">
                    <div class="p-d-flex p-jc-between p-ai-center"> RegistrationID <p-sortIcon field="registrationId"></p-sortIcon></div>
                  </th>

                  <th class="registrationDateTD" pSortableColumn="registrationDate">
                    <div class="p-d-flex p-jc-between p-ai-center"> Registration Date <p-sortIcon field="registrationDate"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tournamentName">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament Name <p-sortIcon field="tournamentName"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tournamentHostedBy" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament Hosted By <p-sortIcon field="tournamentHostedBy"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="academyId" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> AcademyID <p-sortIcon field="academyId"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tournamentCity" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament City <p-sortIcon field="tournamentCity"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tournamentState" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament State <p-sortIcon field="tournamentState"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tournamentCountry" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament Country <p-sortIcon field="tournamentCountry"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="category" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Category <p-sortIcon field="category"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="entryFee" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Entry Fee <p-sortIcon field="entryFee"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="couponApplied" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Applied <p-sortIcon field="couponApplied"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tournamentStartDate" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament Start Date <p-sortIcon field="tournamentStartDate"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tournamentEndDate" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Tournament End Date <p-sortIcon field="tournamentEndDate"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountHost" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (Host) <p-sortIcon field="couponDiscountAmountHost"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="couponDiscountAmountTPL" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Coupon Discount Amount (TPL) <p-sortIcon field="couponDiscountAmountTPL"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tplCommissionPercent" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission % <p-sortIcon field="tplCommissionPercent"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tplCommission" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Commission <p-sortIcon field="tplCommission"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="finalEntryFee" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Final Entry Fee (TPL Revenue) <p-sortIcon field="finalEntryFee"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="gstAmount" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> GST Amount <p-sortIcon field="gstAmount"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="entryFeePayoutToAcademy" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Entry Fee Payout to Academy <p-sortIcon field="entryFeePayoutToAcademy"></p-sortIcon></div>
                  </th>

                  <th class="BankDteailsTD" pSortableColumn="tplShare" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> TPL Share <p-sortIcon field="tplShare"></p-sortIcon></div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                      [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                  </th>
                  <th class="userNameTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'username', 'contains')"
                      [value]="dt.filters['username'] ? dt.filters['username'].value : ''" />
                  </th>
                  <th class="academyTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academy', 'contains')"
                      [value]="dt.filters['academy'] ? dt.filters['academy'].value : ''" />
                  </th>
                  <th class="sportTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'sport', 'contains')"
                      [value]="dt.filters['sport'] ? dt.filters['sport'].value : ''" />
                  </th>
                  <th class="transferCreditTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'registrationId', 'contains')"
                      [value]="dt.filters['registrationId'] ? dt.filters['registrationId'].value : ''" />
                  </th>
                  <th class="registrationDateTD show-col">
                    <input pInputText type="date"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'registrationDate', 'equals')"
                      [value]="dt.filters['registrationDate'] ? dt.filters['registrationDate'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentName', 'contains')"
                      [value]="dt.filters['tournamentName'] ? dt.filters['tournamentName'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentHostedBy', 'contains')"
                      [value]="dt.filters['tournamentHostedBy'] ? dt.filters['tournamentHostedBy'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyId', 'contains')"
                      [value]="dt.filters['academyId'] ? dt.filters['academyId'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentCity', 'contains')"
                      [value]="dt.filters['tournamentCity'] ? dt.filters['tournamentCity'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentState', 'contains')"
                      [value]="dt.filters['tournamentState'] ? dt.filters['tournamentState'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentCountry', 'contains')"
                      [value]="dt.filters['tournamentCountry'] ? dt.filters['tournamentCountry'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'category', 'contains')"
                      [value]="dt.filters['category'] ? dt.filters['category'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'entryFee', 'equals')"
                      [value]="dt.filters['entryFee'] ? dt.filters['entryFee'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponApplied', 'contains')"
                      [value]="dt.filters['couponApplied'] ? dt.filters['couponApplied'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="date"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentStartDate', 'equals')"
                      [value]="dt.filters['tournamentStartDate'] ? dt.filters['tournamentStartDate'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="date"
                      (change)="setDownloadFlag(); dt.filter($event.target.value, 'tournamentEndDate', 'equals')"
                      [value]="dt.filters['tournamentEndDate'] ? dt.filters['tournamentEndDate'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountHost', 'equals')"
                      [value]="dt.filters['couponDiscountAmountHost'] ? dt.filters['couponDiscountAmountHost'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'couponDiscountAmountTPL', 'equals')"
                      [value]="dt.filters['couponDiscountAmountTPL'] ? dt.filters['couponDiscountAmountTPL'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommissionPercent', 'equals')"
                      [value]="dt.filters['tplCommissionPercent'] ? dt.filters['tplCommissionPercent'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplCommission', 'equals')"
                      [value]="dt.filters['tplCommission'] ? dt.filters['tplCommission'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'finalEntryFee', 'equals')"
                      [value]="dt.filters['finalEntryFee'] ? dt.filters['finalEntryFee'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gstAmount', 'equals')"
                      [value]="dt.filters['gstAmount'] ? dt.filters['gstAmount'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'entryFeePayoutToAcademy', 'equals')"
                      [value]="dt.filters['entryFeePayoutToAcademy'] ? dt.filters['entryFeePayoutToAcademy'].value : ''" />
                  </th>
                  <th class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <input pInputText type="number"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'tplShare', 'equals')"
                      [value]="dt.filters['tplShare'] ? dt.filters['tplShare'].value : ''" />
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-tournamentRevenueList>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{tournamentRevenueList.mobileNumber}}" tooltipPosition="bottom">
                      {{tournamentRevenueList.mobileNumber}}
                    </div>
                  </td>

                  <td class="userNameTD">
                    {{ tournamentRevenueList.username }}
                  </td>
                  <td class="academyTD">
                    {{ tournamentRevenueList.academy }}
                  </td>
                  <td class="sportTD">
                    {{ tournamentRevenueList.sport }}
                  </td>
                  <td class="transferCreditTD">
                    {{ tournamentRevenueList.registrationId }}
                  </td>
                  <td class="registrationDateTD">
                    {{ tournamentRevenueList?.registrationDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="BankDteailsTD">
                    {{ tournamentRevenueList?.tournamentName }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tournamentHostedBy }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.academyId }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tournamentCity }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tournamentState }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tournamentCountry }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.category }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.entryFee }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.couponApplied }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tournamentStartDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tournamentEndDate | date:'dd/MM/yyyy' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.couponDiscountAmountHost > 0 ? tournamentRevenueList.couponDiscountAmountHost : '-' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.couponDiscountAmountTPL > 0 ? tournamentRevenueList.couponDiscountAmountTPL : '-' }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tplCommissionPercent }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tplCommission }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.finalEntryFee }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.gstAmount }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.entryFeePayoutToAcademy }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ tournamentRevenueList?.tplShare }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Tournament revenue list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
